import React from "react";
import { AGTable } from "components";
import { connect } from "react-redux";
import { shipmentCarrierGrid } from "./tables/shipmentCarrierGrid";

const ShipmentCarrierView = ({ modal: { selectedData } }) => {
  return (
    <>
      <div className="modal-body">
        <AGTable
          isDoneLoading={true}
          isSearchEnable={true}
          tableName="shipmentCarrierView"
          gridConfig={shipmentCarrierGrid}
          rowData={[selectedData.carrier]}
        />
      </div>
    </>
  );
};
export default connect(({ modal }) => ({ modal }), {})(ShipmentCarrierView);
